<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="305px"
    class="transparent-dialog"
    :show-close="false"
  >
    <div class="dialog-content">
      <img src="https://pstatic.navi-sci.cn/integral/integral-pop.png" class="dialog-img" />
      <div class="exchange-content">
        <div class="exchange-title">兑换确认</div>
        <div class="exchange-icon">
            <img src="https://pstatic.navi-sci.cn/integral/integral-pop_1.png" class="exchange-img" />
        </div>
        <div class="exchange-desc">
            <span>你本次兑换的奖品是“{{item.mallName}}”，消耗积分{{item.redeemPoints}}是否确认兑换，兑换后不可取消！（注意：</span>
            <span style="color:#FF1414;">该奖品会以等比例京东锦鲤商城积分形式发放</span>
            <span>）</span>
        </div>
        <div class="exchange-btn">
            <el-button type="default" round class="cancel-btn" @click="handleCancel">取消</el-button>
            <el-button type="primary" round class="confirm-btn" @click="handleConfirm">确认</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      item: {}
    }
  },
  methods: {
    handleClose() {
      // 关闭对话框前的处理
    },
    publicOpen(item) {
        this.item = item
      this.dialogVisible = true
    },
    handleConfirm() {
      this.$emit('confirm', this.item)
      this.dialogVisible = false
    },
    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.transparent-dialog {
  background-color: transparent;
  box-shadow: none;
}
.transparent-dialog ::v-deep .el-dialog{
    background-color: transparent;
    box-shadow: none;
}
.transparent-dialog ::v-deep .el-dialog__header,
.transparent-dialog ::v-deep .el-dialog__body {
  padding: 0;
  background:transparent;
  border-radius: 25px;
  overflow: hidden;
}

.dialog-content {
  width: 305px;
  height: 330px;
  display: flex;
  .dialog-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
  .exchange-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    .exchange-title {
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: bold;
        color: #832604;
    }
    .exchange-icon {
        width: 110px;
        height: 90px;
        .exchange-img {
            width: 100%;
            height: 100%;
        }
    }
    .exchange-desc{
        font-size: 13px;
        color: #882F0E;
        margin: 10px 20px 0px 20px;
        line-height: 1.5;
    }
    .exchange-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex:1;
        width: 100%;
        .cancel-btn {
            width: 30%;
        }
        .confirm-btn {
            background: linear-gradient( 180deg, #FEE49F 0%, #FE3F1B 100%);
            width: 30%;
            border: none;
            margin-left: 20px;
        }
    }
  }
}
</style>